import React from 'react';
import SystemProperList from "modules/_Manage/SystemProps/components/SystemPropertyList";

const SystemProps = () => {
    return (
        <SystemProperList propertyType={0} />
    );   
}

export default SystemProps;